<template>
  <AdminLayout>
    <v-row class="mb-16 gutters">
      <v-col cols="12" class="mx-xs-auto d-flex flex-column height">
        <v-text-field
          v-model="search"
          label="Benutzergruppen suchen..."
          append-inner-icon="mdi-magnify"
          variant="solo"
          clearable
          class="search-field"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="api.userGroups"
          :search="search"
          :footer-props="{
            'items-per-page-all-text': 'Alle',
            'items-per-page-text': 'Gruppen pro Seite',
          }"
          class="bg-accent elevation-1"
          fixed-header
          :loading="loading"
          loading-text="Daten werden geladen..."
        >
          <template #loader>
            <v-progress-linear
              indeterminate
              color="primary"
              height="4"
            ></v-progress-linear>
          </template>
          <template v-slot:item.name="{ item }">
            {{ item.name }}
          </template>
          <template v-slot:item.tenantId="{ item }">
            <span>
              {{ item.tenantId ? "Mandanten-Ebene" : "Instanz-Ebene" }}
            </span>
          </template>
          <template v-slot:item.allowAssignmentToTenantUsers="{ item }">
            <div class="ml-15">
              <v-checkbox
                v-if="!item.tenantId"
                v-model="item.allowAssignmentToTenantUsers"
                hide-details
                color="primary"
                readonly
              ></v-checkbox>
              <span v-else class="ml-2">-</span>
            </div>
          </template>
          <template v-slot:item.controls="{ item }">
            <v-menu>
              <template v-slot:activator="{ props }">
                <v-btn icon variant="text" v-bind="props" size="small">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  link
                  @click="onOpenEditGroups(item.id)"
                  :disabled="!isInstanceOwner && item.tenantId === null"
                  prepend-icon="mdi-pencil"
                >
                  <v-list-item-title
                    >Benutzergruppe bearbeiten</v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  link
                  @click="onOpenDeleteDialog(item.id)"
                  :disabled="!isInstanceOwner && item.tenantId === null"
                  prepend-icon="mdi-delete"
                >
                  <v-list-item-title>Benutzergruppe löschen</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-btn
      color="primary"
      fixed
      size="large"
      rounded
      class="position-fixed bottom-0 right-0 mb-4 mr-5"
      @click="onOpenCreateGroup"
    >
      <v-icon>mdi-plus</v-icon>Benutzergruppe Erstellen
    </v-btn>
    <UserGroupEdit
      :group="selectedUserGroup"
      :open="openEditDialog"
      @close="onCloseDialog"
    />
    <UserGroupDeleteConfirmationDialog
      :toDelete="selectedUserGroup"
      :open="openDeleteDialog"
      @close="onCloseDeleteDialog"
    />
  </AdminLayout>
</template>

<script>
import AdminLayout from "@/layouts/Admin.vue";
import UserGroupEdit from "@/components/UserGroup/UserGroupEdit";
import { mapActions, mapGetters } from "vuex";
import UserGroupDeleteConfirmationDialog from "@/components/UserGroup/UserGroupDeleteConfirmationDialog";
import ApiUserGroupService from "../../services/api/ApiUserGroupService";

export default {
  components: {
    UserGroupDeleteConfirmationDialog,
    AdminLayout,
    UserGroupEdit,
  },
  data() {
    return {
      search: "",
      api: {
        userGroups: [],
      },
      headers: [
        {
          title: "Gruppenname",
          align: "start",
          value: "name",
        },
        { title: "Typ", value: "tenantId" },
        {
          title: "Mandanten können zuweisen",
          value: "allowAssignmentToTenantUsers",
          sortable: false,
        },
        { title: "", value: "controls", sortable: false },
      ],
      openEditDialog: false,
      openDeleteDialog: false,
      selectedUserGroup: {},
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading/isLoading",
      tenantId: "tenants/currentTenantId",
      isInstanceOwner: "user/isInstanceOwner",
    }),
  },
  watch: {
    tenantId() {
      this.fetchUserGroups();
    },
  },
  methods: {
    ...mapActions({
      startLoading: "loading/start",
      stopLoading: "loading/stop",
    }),
    fetchUserGroups() {
      this.startLoading("fetch-user-groups");
      ApiUserGroupService.getUserGroups()
        .then((response) => {
          this.api.userGroups = response;
        })
        .finally(() => {
          this.stopLoading("fetch-user-groups");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onOpenEditGroups(groupId) {
      this.selectedUserGroup = Object.assign(
        {},
        this.api.userGroups.find((group) => group.id === groupId)
      );
      this.openEditDialog = true;
    },
    onOpenDeleteDialog(groupId) {
      this.selectedUserGroup = Object.assign(
        {},
        this.api.userGroups.find((group) => group.id === groupId)
      );
      this.openDeleteDialog = true;
    },
    onCloseDialog() {
      this.fetchUserGroups();
      this.openEditDialog = false;
    },
    onCloseDeleteDialog() {
      this.fetchUserGroups();
      this.openDeleteDialog = false;
    },
    onOpenCreateGroup() {
      this.selectedUserGroup = {};
      this.openEditDialog = true;
    },
  },
  created() {
    this.fetchUserGroups();
  },
};
</script>

<style scoped>
.search-field {
  border-radius: 15px;
}
</style>
